import { createContext } from 'react';

import type { UserContextValue } from './userContextTypes';

export const UserContext = createContext<UserContextValue | null>(null);
